import d3 from 'd3';
import { solve } from 'numeric';

var observer, width, height, tileWidth;
width = 220;
height = 200;
if (!d3.select('body.what-we-do').empty()) {
  tileWidth = d3.select('.ecosystem__tile').node().clientWidth;
} else {
  tileWidth = 0;
}

// d3.select("body")
//   .selectAll("svg")
//   .data(["transform", "flat"])
//   .enter()
//   .append("svg");

// d3.select("body")
//   .selectAll("svg")
//   .attr("id", (d) => d)
//   .attr("width", width)
//   .attr("height", height);

var transform =
  ["", "-webkit-", "-moz-", "-ms-", "-o-"].reduce(function (p, v) {
    return v + "transform" in document.body.style ? v : p;
  }) + "transform";

var sourcePoints = [
    [0, 0],
    [width, 0],
    [width, height],
    [0, height]
  ],
  targetPoints = [
    [0, -5],
    [86, 14],
    [86, 187],
    [0, height + 5]
  ];

var imgWrappers = d3
    .selectAll(".ecosystem__tile-wrapper")
      .data([0, 20, 40, 60, 80, 100])

var svgTransform = d3
  .selectAll(".ecosystem__tile")
  	.style(transform + "-origin", 0 + "px " + 0 + "px 0");

function transformed() {
  for (var a = [], b = [], i = 0, n = sourcePoints.length; i < n; ++i) {
    var s = sourcePoints[i],
      t = targetPoints[i];
    a.push([s[0], s[1], 1, 0, 0, 0, -s[0] * t[0], -s[1] * t[0]]), b.push(t[0]);
    a.push([0, 0, 0, s[0], s[1], 1, -s[0] * t[1], -s[1] * t[1]]), b.push(t[1]);
  }

  var X = numeric.solve(a, b, true),
    matrix = [
      X[0],
      X[3],
      0,
      X[6],
      X[1],
      X[4],
      0,
      X[7],
      0,
      0,
      1,
      0,
      X[2],
      X[5],
      0,
      1
    ].map(function (x) {
      return d3.round(x, 6);
    });

  svgTransform.style(transform, "matrix3d(" + matrix + ")");
}

// d3.selectAll("g")
//   .transition()
//   .ease(options.translateEasingFunction)
//   .delay(function (d, i) {
//     return options.translateDelay - (1 + i * options.translateStagger);
//   })
//   .duration(options.translateDuration)
//   .attr("transform", (d) => `translate(${options.translateDistance * d})`);

// d3.selectAll("path")
//   .transition()
//   .ease(options.rotateEasingFunction)
//   .delay(function (d, i) {
//     return options.rotateDelay - (1 + i * options.rotateStagger);
//   })
//   .duration(options.rotateDuration)
//   .attr("d", "M 0 208.12 L 0.5 9.12 L 219.5 9.12 L 219.5 208.12 Z");

var options = {
  initialTranslateDistance: 30,
  rotateDelay: 1000,
  rotateDuration: 1000,
  rotateEasingFunction: d3.easeCubic,
  rotateStagger: 200,
  translateDelay: 900,
  translateDistance: 1.05 * tileWidth,
  translateDuration: 1500,
  translateEasingFunction: d3.easeCubic,
  translateStagger: 200
};

function fadeIn(argument) {
  d3.selectAll('.ecosystem__tile :not(.backdrop)')
    .transition()
    .delay(function (d, i) {
      return i * 7;
    })
    .style('opacity', 1)
}

function animate(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      imgWrappers.transition()
      .delay(function (d, i) {
        return options.translateDelay - (1 + i * options.translateStagger);
      })
      .duration(options.translateDuration)
        .styleTween('transform', function() {
          var startX = d3.select(this).datum();
          var startString = `translateX(${startX}px)`;
          var index = d3.select(this).attr('data-index');
          var endString = `translateX(${options.translateDistance * index}px)`;
          return d3.interpolateString(
            startString,
            endString)
        })

      d3.transition()
      .delay(function (d, i) {
        return options.rotateDelay - (1 + i * options.rotateStagger);
      })
      .duration(options.rotateDuration)
      .tween("points", function () {
        var i = d3.interpolate(targetPoints, sourcePoints);
        return function (t) {
          targetPoints = i(t);
          transformed();
        };
      })
      .each("end", fadeIn);

      observer.disconnect();
    }
  });
}



if ( !d3.select('body.what-we-do').empty() && window.innerWidth > 1140 ) {
  observer = new IntersectionObserver(animate, {
    rootMargin: "0px",
    threshold: 1.0
  });
  d3.selectAll('.ecosystem__tile :not(.backdrop)').style('opacity', 0);
  var ecosystemWrapper = document.getElementById("ecosystem-wrapper-js");
  observer.observe(ecosystemWrapper);  
}
